import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlusSmall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPlusSmall"><Path fillRule="evenodd" clipRule="evenodd" d="M12.75 6V11.25H18V12.75H12.75V18H11.25V12.75H6V11.25H11.25V6H12.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlusSmall;
